import styled from 'styled-components'
import theme from '../../styles/theme.css'

export const ContainerQ = styled.div`
    max-width: 680px;
    width: 90%;
    margin: 1rem auto 1.5rem auto;
    text-align: left;
    font-size: 1rem;
    p{
        font-family: ${theme.aprecuPro};
        font-weight: 400;
        strong{
            font-weight: bold;
        }
    }
`